import {connect} from 'react-redux';

import {getCustomFieldsForCards} from '../../../../../../../../src/store/data/customFields/customFieldsSelectors';
import {getIsUserGlobalAdmin} from '../../../../../../../../src/store/data/teammates/teammatesSelectors';
import {makeGetContactsManagerCreateContactFormState} from '../../../../../../../../src/store/panels/contacts/contactsManager/contactsManagerPanelSelectors';
import {createContactFormUpdateCustomAttributeAction} from '../../../../../../../../src/store/panels/contacts/createContactForm/createContactFormActions';
import {ContactsManagerPanelId} from '../../../../../../../../src/store/panels/panelStateBase';
import {navigateToLinkAction} from '../../../../../../../../src/store/stateless/navigationActions';
import {
  createSelector,
  makeMapDispatchToProps,
  makeMapStateToProps,
} from '../../../../../../../../srcCommon/helpers/reselectHelpers';
import {CreateContactCustomAttributes} from './createContactCustomAttributes';

/*
 * Props.
 */

interface CreateContactCustomAttributesContainerProps {
  panelId: ContactsManagerPanelId;
}

/*
 * Selectors.
 */

function makeGetCustomAttributes() {
  return createSelector([makeGetContactsManagerCreateContactFormState()], (formState) => {
    if (!formState) {
      return [];
    }
    return formState.customAttributes;
  });
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<CreateContactCustomAttributesContainerProps>()(() => ({
  customFields: getCustomFieldsForCards,
  customAttributes: makeGetCustomAttributes(),
  isUserGlobalAdmin: getIsUserGlobalAdmin,
}));

const mapDispatchToProps = makeMapDispatchToProps<CreateContactCustomAttributesContainerProps>()(
  ({panelId}) => ({
    onUpdateCustomAttribute: (customFieldId: number, value: string) =>
      createContactFormUpdateCustomAttributeAction(panelId, customFieldId, value),
    onNavigateToCustomFieldsSettings: () =>
      navigateToLinkAction('/settings/global/custom-fields/cards/overview'),
  }),
);

export const CreateContactCustomAttributesContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(CreateContactCustomAttributes);
